import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import VirtualIssuedCard from "./VirtualIssuedCard";
import styles from "./IssuedCardSuccessModal.module.scss";


const IssuedCardSuccessModal = ({
  show,
  handleClose,
  lastFour,
  holderName,
  expiryLabel,
  statusText,
  cardCategory,
  cardType,
  showViewCard = true,
}) => {
  const navigate = useNavigate();

  const categoryLabel =
    cardCategory === "PHYSICAL" ? "Physical" : "Virtual";

  const statusLower = statusText?.trim().toLowerCase();
  const displayStatus =
    statusLower === "approved" || statusLower === "approve"
      ? "Active"
      : statusText;

  const goDone = () => {
    handleClose();
    navigate(ROUTES.STBL_MONEY);
  };

  return (
    <Modal
      className={`${styles.modalWide}`}
      show={show}
      handleClose={handleClose}
      title={false}
    >
      <div className={styles.wrap}>
        <div className={styles.congrats}>
          <h2 className={styles.title}>Congratulations!</h2>
          <p className={styles.subtitle}>
            Your STBL Card is now active and ready to use. Enjoy secure and
            seamless transactions with your new card.
          </p>
        </div>
        <div className={styles.cardSlot}>
          <VirtualIssuedCard
            // cardCategoryLabel={categoryLabel}
            lastFour={lastFour}
            holderName={holderName}
            expiryLabel={expiryLabel}
            statusText={displayStatus}
            cardType={cardType}
          />
        </div>
            {displayStatus ? <div className={styles.status}>{displayStatus}</div> : null}

        <Button fluid className={styles.doneBtn} onClick={goDone}>
          View Card
        </Button>
      </div>
    </Modal>
  );
};

export default IssuedCardSuccessModal;
